<template>
  <div>
    <img class="m-b-15" src="../../../assets/images/modals/ico060.svg" alt="Wait for Confirmation Call">
    <text-string label-id="txt365" class="m-b-10"/>
    <text-string label-id="txt366"/>
  </div>
</template>

<script>
  export default {
    name: "modal-view-pharmacy-orders-step-three"
  }
</script>

<style scoped>

</style>